import { createContext } from 'react';

const UserContentValuesContext = createContext({});

export default UserContentValuesContext;
